import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {IIndexable} from "../../../domain/interfaces";
import {getJSONFromHtml} from "../../../domain/common";
import {FreePluginsDM, GetFreePluginsDM} from "../interfaces";
import {IPurchased} from "../../membership/purchased-products/interfaces";
import {getHideMyProducts} from "../../list-page/services/list-page-provider";
import {getIsAuthenticated} from "../../../domain/hidden-data-provider";

const _pageData = getJSONFromHtml(document.getElementById('get-free-plugins-data')) as GetFreePluginsDM;
const _hideMyProducts = getHideMyProducts();
const _isUserLoggedIn = getIsAuthenticated();

export interface StateInterface extends IIndexable{
    // campaign & products data received from the JSON printed on the page
    PageData: GetFreePluginsDM;
    // the data list filtered by the search term & product I own
    filteredItems: FreePluginsDM[];
    // products appears in the session storage in the 'purchased' array
    purchased:IPurchased|null;
    imgCdnDomain:string;
    // search term value entered by the user in the search box
    filterTerm:string;
    currentPage:number;
    //if the user is logged in --> get the value from session storage
    hideProductsOwn:boolean;
    // true if login popup is opened
    showLoginPage:boolean;
    // true if EFS popup is opened
    showEfsPopup:boolean;
    isLoggedInForFreePlugin:boolean;
    //clicked item's code
    itemCode:string;
    //clicked item's name
    selectedItemDescription:string;
    reply:string;
    isPageLoad:boolean;

    // https://wavesaudio.atlassian.net/browse/MRKT-22757
    isTopPopupOpened: boolean;
}
// initial state
const initialState: StateInterface = {
    PageData: _pageData,
    filteredItems: _pageData.freePlugins,
    purchased:null,
    imgCdnDomain:(document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase(),
    filterTerm:"",
    currentPage:0,
    hideProductsOwn:_isUserLoggedIn ? _hideMyProducts : false,
    showLoginPage:false,
    showEfsPopup:false,
    isLoggedInForFreePlugin:false,
    itemCode:"",
    selectedItemDescription:"",
    reply:"",
    isPageLoad:true,

    // https://wavesaudio.atlassian.net/browse/MRKT-22757
    isTopPopupOpened: false,
}
// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

